import { createTestIds } from '@duke-hq/lib/createTestId';

export const testIds = createTestIds('apps-admin-web-components-translations-OverrideEditor', [
  'workbench',
  'backLink',
  'header',
  'languageSwitcher',
  'languageSwitcherItem',
  'editsCrumb',
  'outlineRail',
  'outlineEntry',
  'outlineCollapse',
  'outlineExpand',
  'filterBar',
  'searchInput',
  'searchClear',
  'filterHuman',
  'filterMachine',
  'filterUntranslated',
  'filterReReview',
  'nextNeedsAttention',
  'seamGrid',
  'nodeGroupHeader',
  'segmentRow',
  'breadcrumb',
  'sourceText',
  'targetText',
  'targetInput',
  'editAffordance',
  'stateRail',
  'staleCaption',
  'resetToMachine',
  'saveButton',
  'saveStatus',
  'failedBanner',
  'readOnlyNote',
  'emptyState',
  'errorRetry',
]);
